/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel' <vishal@wakencode.com>, May 2020
 *
 *****************************************************************************/

import React from "react";
import { InfoWindow } from "@react-google-maps/api";
import { useSelector, shallowEqual } from "react-redux";
import { filterByJobType } from "./../../../shared/geofence";
import { constant } from "../../../shared/constants/constants";

// show info windows
const GeometryInfo = () => {
  const properties = useSelector(
    (state) => state.geofence.geofenceData,
    shallowEqual
  );
  const isVisible = useSelector(
    (state) => state.geoUtil.showInfoWindow,
    shallowEqual
  );
  const jobType = useSelector((state) => state.geoUtil.jobType, shallowEqual);

  let info = [];
  if (isVisible) {
    // filter property by jobType
    let dataToBeShown = filterByJobType(properties, jobType);
    for (let property of dataToBeShown) {
      for (let poly of property.geometries) {
        info.push(
          <InfoWindow
            key={poly.gid}
            position={{
              lat: poly.center.lat,
              lng: poly.center.lng,
            }}>
            <div>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={`${process.env.REACT_APP_MSA_URL}${constant.PROPERTY_URL}/${property.propertyId}`}>
                {property.propertyName}
              </a>
            </div>
          </InfoWindow>
        );
      }
    }
  }

  return info;
};

export default React.memo(GeometryInfo);
